export function generateDays() {
  return Array.from({ length: 31 }, (_, i) => ({ label: i + 1, value: i + 1 }));
}

export function generateMonths() {
  return Array.from({ length: 12 }, (_, i) => ({ label: i + 1, value: i + 1 }));
}

export function generateYears() {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 100 }, (_, i) => ({
    label: currentYear - i,
    value: currentYear - i,
  }));
}
